import { CandidateList, CandidateDetail, CandidateBoard, InterviewProcess } from './views'

// Hem IS the candidate list — there is no separate landing page with nav tiles any more
// (same call kayentaStories made when its Hem became the timeline). `/list` stays
// registered as an alias so older links and bookmarks keep resolving; it renders the same
// view. Literal paths come before `/:uuid`, or react-router reads /recruitment/interviews
// as a candidate whose uuid is "interviews".
export const routesConfig = (appName, displayName) => ([
  { path: `/${appName}/list`,       element: CandidateList,    breadcrumb: 'Kandidater' },
  { path: `/${appName}/board`,      element: CandidateBoard,   breadcrumb: 'Pipeline' },
  { path: `/${appName}/interviews`, element: InterviewProcess, breadcrumb: 'Intervjuprocess' },
  { path: `/${appName}/:uuid`,      element: CandidateDetail,  breadcrumb: 'Kandidat' },
  { path: `/${appName}/`,           element: CandidateList,    breadcrumb: displayName },
])
